
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}} {{website.lat}} {{website.lng}}</p>
                                        </div>
                                        <website-menu></website-menu>
                                        <div class="btns">
                                            <div class="btns_sxs">
                                                <md-button class="md-primary" @click="save" title="Attempt to save all changes">Save All</md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="md-layout-item md-size-100 building-location poi_map">
                                    <div id="googlemap"></div>
                                </div>

                                <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <h3 class="zero_b_margin">Street View {{website.streetView.heading}} {{website.streetView.lat}} {{website.streetView.lng}} {{website.streetView.zoom}}</h3>
                                    <div id="street-view"></div>
                                </div>

                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    import getCurrentConfig from "@/ts/customConfig";
    import { Loader as GoogleLoader } from "google-maps";
    const googleLoader = new GoogleLoader(getCurrentConfig().googleMapsApiKey);

    import GMapsHelp from "@/ts/GMapsHelp";
    import GStreetViewHelp from "@/ts/GStreetViewHelp";

    import WebsiteMenu from "./WebsiteMenu.vue";

    export default {
        components: {
            Loader
            , FadeTransition
            , WebsiteMenu
        },
        data() {
            return {
                loading: true,
                website: null,
                google: null,
                buildingMarker: null,
                panorama: null
            }
        },
        computed: {

        },
        methods: {
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getWebsiteStreetView(this.$route.params.buildingId);
                        this.website = res;
                    }
                    this.loading = false;
                }
            },
            setupMap(google, self) {
                self.google = google;
                const myLatlng = new google.maps.LatLng(self.website.lat, self.website.lng);
                self.map = new window.google.maps.Map(document.getElementById("googlemap"), { zoom: GMapsHelp.zoomLevelDefaultStreetViewWiz, center: myLatlng, mapTypeId: "hybrid" });
                self.buildingMarker = new window.google.maps.Marker({ position: myLatlng, title: self.website.name, draggable: true });
                self.buildingMarker.setMap(self.map);

                self.buildingMarker.addListener('dragend', evt => {
                    var lat = evt.latLng.lat();
                    var lng = evt.latLng.lng();
                    self.website.lat = lat;
                    self.website.lng = lng;
                });

                //self.map.addListener("zoom_changed", () => { console.log("map zoom_changed " + self.map.getZoom()); });

                var streetViewElement = document.getElementById("street-view");
                self.panorama = GStreetViewHelp.initialize(streetViewElement, self.website.streetView);

                self.map.setStreetView(self.panorama);

                self.panorama.addListener("position_changed", () => {
                    var lat = self.panorama.getPosition().lat();
                    var lng = self.panorama.getPosition().lng();
                    self.website.streetView.lat = lat;
                    self.website.streetView.lng = lng;
                });

                self.panorama.addListener("pov_changed", () => {
                    var heading = self.panorama.getPov().heading + "";
                    var pitch = self.panorama.getPov().pitch + "";
                    self.website.streetView.heading = Math.round(Number(heading));
                    self.website.streetView.pitch = Math.round(Number(pitch));
                });

                self.panorama.addListener("zoom_changed", () => { //https://developers.google.com/maps/documentation/javascript/examples/streetview-simple
                    var zoom = self.panorama.getZoom();
                    self.website.streetView.zoom = Math.round(zoom);
                });
            },
            async save() {
                var res = await Api.websites.upsertStreetView(this.website);
                if (res.success === true) {
                    alert("that worked");
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
        },
        async mounted() {
            await this.fetchData();
            var self = this;
            if (window.google && window.google.maps) {
                self.setupMap(window.google, self);
            }
            else {
                googleLoader.load().then(function (google) {
                    self.setupMap(google, self);
                });
            }
        },

    }
</script>
<style lang="scss">
</style>